import Head from "next/head"
import * as React from "react"

import { NewGradScoutCorpContact } from "~/components/pages/NewGradScoutCorpContactPage"
import { staticPath } from "~/services/helper"

const NewGradJobCorpContactPage: React.FC = () => {
  return (
    <>
      <Head>
        <title>Infra 新卒スカウト | ここでしか出会えない優秀な早期行動学生に、いち早くスカウトでアプローチ</title>
        <meta
          name="description"
          content="Infra 新卒スカウトは、長期インターンなどを通じて早期から将来に向けて行動している優秀な早期行動学生にいち早くスカウトでアプローチできるサービスです。"
        />
        <meta
          property="og:title"
          content="Infra 新卒スカウト | ここでしか出会えない優秀な早期行動学生に、いち早くスカウトでアプローチ"
        />
        <meta
          property="og:description"
          content="Infra 新卒スカウトは、長期インターンなどを通じて早期から将来に向けて行動している優秀な早期行動学生にいち早くスカウトでアプローチできるサービスです。"
        />
        <meta
          property="og:image"
          content={`${process.env.APP_HOST + staticPath("/static/images/new-grad-scout/corp-contact/ogp.png")}`}
        />
        <meta name="viewport" content="initial-scale=1,viewport-fit-cover" />
      </Head>
      <NewGradScoutCorpContact />
    </>
  )
}

export default NewGradJobCorpContactPage
